import { action, onConnect, sleep } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { UnknownError } from '@root/shared'
import { reatomRequest } from '@root/shared/lib'

import type { PairModel } from '@root/entities/pair'
import type { WalletAddress } from '@root/entities/wallet'

export type TempMonitorSquareEntry = {
  pair: PairModel
  makerAddress: WalletAddress
}

export const reatomMonitorSquare = () => {
  const verifyInternalAction = action(
    async (
      ctx,
    ): Promise<Result.Result<Array<TempMonitorSquareEntry>, UnknownError>> => {
      await ctx.schedule(() => sleep(300))

      // const tempItems = Array.range(1, 10).map(
      //   (_it): TempMonitorSquareEntry => ({
      //     pair: createPairModelStub(),
      //     makerAddress: WalletAddress(nanoid()),
      //   }),
      // )
      return Result.fail(UnknownError.fromUnknown('not implemented'))

      // return Result.succeed(tempItems)
    },
    'verifyInternalAction',
  )

  const requestState = reatomRequest({
    execAction: verifyInternalAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'verificationRequest',
  })

  onConnect(requestState, (ctx) => requestState.execute(ctx))

  return requestState
}
